module.exports = __webpack_public_path__ + "img/logoface_1.003dbf3e.svg";